<div class="min-h-screen flex flex-col">
  @if (title(); as salonTitle) {
    <app-header [title]="salonTitle"></app-header>
  } @else {
    <app-header [title]="'i18n.home.title' | translate"></app-header>
  }

  <main class="bg-surface flex-1 flex flex-col">
    @if (isLoading()) {
      <div class="flex flex-1 items-center justify-center">
        <div class="text-center">
          <app-loading-spinner></app-loading-spinner>
          <h2 class="text-content mt-4">{{ 'i18n.loadingSpinner.title' | translate }}</h2>
        </div>
      </div>
    } @else {
      <router-outlet></router-outlet>
    }
  </main>

  <app-footer class="mt-16"/>
</div>
<app-toast />
